// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// RemoveAwardFromNewProgramProgramHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import NewProgramChangeRequestDTO from '../models/NewProgramChangeRequestDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    newProgramChangeRequest: NewProgramChangeRequestDTO | null;
    awardId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            newProgramChangeRequest: null,
            awardId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    newProgramChangeRequest: 'newProgramChangeRequest',
    awardId: 'awardId',
}

interface Result extends ResultDTO {
    newProgramChangeRequest: NewProgramChangeRequestDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            newProgramChangeRequest: null,
        },
        initValues);
    },
    newProgramChangeRequest: 'newProgramChangeRequest',
}

export { Request, Result };